export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20digital%20illustration%20with%20soft%20coral%20red%20and%20cream%20gradients%2C%20modern%20editorial%20design%20background%2C%20subtle%20geometric%20patterns%2C%20luxurious%20magazine%20layout%20feel%2C%20dramatic%20lighting%20with%20warm%20golden%20accents%2C%20clean%20sophisticated%20aesthetic%2C%20no%20text%2C%20smooth%20gradients&width=1800&height=900&seq=hero-bg-chigua&orientation=landscape"
          alt="吃瓜爆料网背景"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              实时追踪 · 深度挖掘
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
              吃瓜爆料网
              <span className="block text-primary-300 text-2xl sm:text-3xl md:text-4xl mt-2">
                全网最全娱乐八卦爆料平台
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-background-300 font-light leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              一手猛料，快人一步。覆盖娱乐圈、网红圈、社会热点全领域爆料资讯，每日更新最新八卦动态，
              汇聚千万吃瓜群众，打造最活跃的娱乐爆料社区。无论是最新明星绯闻还是网络热议话题，
              吃瓜爆料网都是你的第一手信息来源。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">50万+</div>
                <div className="text-xs text-background-400 mt-1">日活吃瓜用户</div>
              </div>
              <div className="w-px h-10 bg-background-400/40"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">24h</div>
                <div className="text-xs text-background-400 mt-1">全天候实时更新</div>
              </div>
              <div className="w-px h-10 bg-background-400/40"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">10万+</div>
                <div className="text-xs text-background-400 mt-1">累计爆料内容</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>
                查看今日热度榜
              </a>
              <a
                href="#topics"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/30 font-medium rounded-lg transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line mr-2"></i>
                探索热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-2xl overflow-hidden bg-background-900/30 backdrop-blur-sm border border-background-50/10">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20editorial%20collage%20style%20with%20warm%20coral%20red%20and%20golden%20amber%20tones%2C%20modern%20magazine%20cover%20aesthetic%2C%20overlapping%20geometric%20shapes%2C%20soft%20glowing%20light%20effects%2C%20luxurious%20art%20direction%2C%20dramatic%20contrast%20lighting%2C%20sophisticated%20pop%20culture%20vibe%2C%20no%20text%2C%20clean%20composition&width=800&height=1000&seq=hero-visual-chigua&orientation=portrait"
                alt="吃瓜爆料网主视觉"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}